import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { get } from "../../_api";
import ListElem from "../List/ListElem";
import { Button, Stack, Text } from "@mantine/core";

export interface IBlogParagraph {
  _id?: string;
  text: string;
  title?: string;
  quotes: string[];
}

export interface IBlogAuthor {
  _id: string;
  name: string;
}

export interface IBlog {
  _id?: string;
  headerTitle: string;
  promoted: boolean;
  authors: IBlogAuthor[];
  categories: string[];
  slug: string;
  shortDescription: string;
  paragraphs: IBlogParagraph[];
  image: string;
  imageTitle: string;
  meta: {
    title?: string;
    readTime: number;
    createdDate: Date;
    description?: string;
    keyWords?: string[];
    any?: string;
  };
}

export const Blog: React.FC = () => {
  const [blogArticles, setBlogArticles] = useState<IBlog[]>([]);
  useEffect(() => {
    get("blog/all").then((res: IBlog[]) => {
      if (res) {
        setBlogArticles(res);
      }
    });
  }, []);

  return (
    <Stack gap="md" maw={1200} mx="auto" px="md" pb={250}>
      <Button component={Link} to="/blog/new" size="md" radius="md" w={{ base: "100%", sm: "auto" }}>
        Dodaj artykuł
      </Button>

      <Stack gap={0}>
        {blogArticles?.length === 0 && <Text>Brak artykułów</Text>}
        {blogArticles?.map((el, i) => (
          <ListElem
            id={el?._id || i.toString()}
            key={el?._id}
            order={i + 1}
            infoBig={el.headerTitle}
            date={el.meta?.createdDate || new Date()}
            link={`/blog/${el._id}`}
          />
        ))}
      </Stack>
    </Stack>
  );
};
